import * as t from 'io-ts';
import { optional } from './helper';

const teamInfo = t.type({
    name: t.string,
    teamId: t.string,
    sportsteamId: t.string,
    logoFull: optional(t.string),
    shortName: t.string,
});

const team = t.type({
    team: teamInfo,
    position: t.number,
    played: t.number,
    won: t.number,
    lost: t.number,
    tied: t.number,
    drawn: optional(t.number),
    noResult: t.number,
    penalty: t.number,
    bonuses: t.number,
    point: t.number,
    netRunRate: optional(t.number),
});

const Groups = t.type({
    groupName: optional(t.string),
    teams: t.array(team),
});

const Data = t.type({
    groups: t.array(Groups),
});

const cricketLogs = t.type({
    data: Data,
    tourId: t.string,
    tourName: t.string,
    logTableType: t.string,
});

export const cricketLogsApiResponse = cricketLogs;
export type CricketTable = t.TypeOf<typeof cricketLogsApiResponse>;
